import { createSvgIconComponent } from "../utils";
export var IconFacebook = createSvgIconComponent({
  viewBox: "0 0 16 16",
  paths: [{
    d: "M12.45 7.38H9.87v8.63h-3.7V7.38H3.7V4.92h2.47V3.49C6.17 2.13 6.6 0 9.43 0l2.9.01v2.84H10.6c-.3 0-.73.15-.73.8v1.26h2.88l-.3 2.46z"
  }]
});